export function CustomPhraseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.0255 8H14.1708C10.7627 8 8 10.7627 8 14.1708V22.0244C8 25.4325 10.7627 28.1952 14.1708 28.1952L12.966 32.0203C12.8154 32.4986 13.3581 32.8951 13.768 32.6061L20.0244 28.1952H27.0255C30.4335 28.1952 33.1963 25.4325 33.1963 22.0244V14.1708C33.1963 10.7627 30.4335 8 27.0255 8Z"
        fill="url(#paint0_linear_2659_12614)"
      />
      <path
        d="M4.7998 14.1719V22.0254C4.7998 25.7416 6.96369 28.9516 10.0996 30.4668L9.91406 31.0596C8.84352 34.4587 12.6997 37.2761 15.6123 35.2227L21.0381 31.3965H27.0254C32.2007 31.3965 36.3965 27.2007 36.3965 22.0254V14.1719C36.3965 8.99655 32.2007 4.80078 27.0254 4.80078H14.1709C8.99557 4.80078 4.7998 8.99655 4.7998 14.1719ZM14.1709 8.00098H27.0254C30.4334 8.00098 33.1963 10.7639 33.1963 14.1719V22.0254C33.1963 25.327 30.6034 28.0234 27.3428 28.1885L27.0254 28.1963H20.0244L13.7676 32.6074L13.6895 32.6533C13.2928 32.8458 12.8249 32.4697 12.9658 32.0215L14.1709 28.1963C10.7629 28.1963 8 25.4334 8 22.0254V14.1719C8 10.7639 10.7629 8.00098 14.1709 8.00098Z"
        fill="url(#paint1_linear_2659_12614)"
      />
      <path
        d="M16.7656 22.5684C16.2034 22.6324 15.7826 22.1668 15.7236 21.6768C15.6917 21.4144 15.7565 21.1443 15.9102 20.9268L15.9092 20.9258C16.0451 20.7326 16.2605 20.6043 16.3125 20.5645C16.3616 20.5268 16.4111 20.4876 16.459 20.4473C16.7184 20.2286 16.9643 19.983 17.1748 19.7187C16.9625 19.6335 16.7637 19.5154 16.583 19.3701C16.0668 18.9565 15.7297 18.3369 15.6318 17.6572C15.5339 16.9781 15.6777 16.2787 16.041 15.7119L16.042 15.7119C16.4273 15.1132 16.9843 14.7464 17.6416 14.6289L17.6504 14.627C17.6674 14.6243 17.6841 14.6222 17.7002 14.6201L17.7012 14.6211C18.2685 14.5467 18.832 14.7013 19.2939 15.043L19.4854 15.2002C19.9922 15.6624 20.3061 16.323 20.3721 17.0313L20.3838 17.2256C20.3892 17.4177 20.3765 17.6025 20.3623 17.7734L20.3174 18.1543C20.1824 19.0327 19.8404 19.8432 19.3408 20.541L19.3389 20.543C18.8113 21.2681 18.1542 21.8668 17.4072 22.2998C17.3416 22.3383 17.2446 22.3959 17.1436 22.4453C17.0485 22.4918 16.9117 22.551 16.7686 22.5684L16.7656 22.5684Z"
        fill="white"
        stroke="url(#paint2_linear_2659_12614)"
        strokeWidth="0.797244"
      />
      <path
        d="M22.7595 22.5684C22.3057 22.6192 21.9682 22.3303 21.8171 22.0117C21.6657 21.6924 21.6564 21.2639 21.9109 20.917C22.042 20.7383 22.1996 20.6432 22.2761 20.5869L22.2771 20.5859L22.4578 20.4453C22.7151 20.2291 22.9576 19.9845 23.1707 19.7187C23.1608 19.7151 23.1504 19.7121 23.1404 19.708L23.1365 19.7061C22.918 19.6153 22.7133 19.4907 22.5291 19.3369L22.53 19.3369C22.0271 18.919 21.7026 18.3032 21.613 17.6309L21.6121 17.6299C21.5225 16.9499 21.6765 16.2528 22.0476 15.6924L22.0486 15.6934C22.4179 15.133 22.9773 14.7471 23.615 14.6357L23.614 14.6348C23.6212 14.6331 23.6292 14.6333 23.6365 14.6318C23.6377 14.6316 23.6391 14.6301 23.6404 14.6299L23.6414 14.6309C23.6573 14.6278 23.6731 14.6241 23.6892 14.6221L23.6882 14.6211C24.334 14.534 24.9768 14.7414 25.4744 15.1816C25.9123 15.569 26.2065 16.1079 26.3191 16.6982L26.3562 16.9531C26.3873 17.2598 26.3649 17.5892 26.3396 17.8574C26.1534 19.8311 24.8962 21.4177 23.407 22.2959C23.3416 22.3345 23.244 22.3932 23.1423 22.4434C23.0455 22.4912 22.9099 22.5499 22.7654 22.5684L22.7595 22.5684Z"
        fill="white"
        stroke="url(#paint3_linear_2659_12614)"
        strokeWidth="0.797244"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2659_12614"
          x1="27.7562"
          y1="0.707293"
          x2="15"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D800" />
          <stop offset="1" stopColor="#027202" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2659_12614"
          x1="13.5552"
          y1="32.3058"
          x2="23.167"
          y2="7.78088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E300" />
          <stop offset="0.52" stopColor="#00FC00" stopOpacity="0.89" />
          <stop offset="0.68" stopColor="#17FC00" stopOpacity="0.92" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2659_12614"
          x1="16.993"
          y1="23.8173"
          x2="22.2601"
          y2="14.4462"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAF970" stopOpacity="0.5" />
          <stop offset="1" stopColor="#7BF744" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2659_12614"
          x1="22.9791"
          y1="23.8173"
          x2="28.2461"
          y2="14.4462"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAF970" stopOpacity="0.5" />
          <stop offset="1" stopColor="#7BF744" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </svg>
  )
}
